import { data } from './data/categories';

export default {
  get() {
    return [200, data];

    // error: タイムアウト
    // return [408, { message: 'タイムアウトしました' }];
  },

  post() {
    return [200, { message: 'お問い合わせ完了しました。' }];
  }
};
